import { useTranslation } from "react-i18next";

import "components/Can/components/NoAccess/NoAccess.scss";

export const NoAccess = () => {
  const { t } = useTranslation();

  return (
    <div className="NoAccess">
      <h1>{t("v8_no_access", "You don't have access to see this page")}</h1>
    </div>
  );
};
